// @flow
import universal from "react-universal-component";
import { UniversalComponentError } from "./src/components/UniversalComponentError";

const sliceNames: Array<string> = [
  "Banner",
  "BannerCta",
  "BannerWithImage",
  "Bookend",
  "BuyingAndSelling",
  "ComparisonTable",
  "Cookies",
  "CustomerStoriesBodyCopy",
  "CustomerStoriesInlineImage",
  "CustomerTestimonial",
  "EmailCaptureHero",
  "EmailSignup",
  "EnquiriesOverTimeGraph",
  "Faqs",
  "FeesHero",
  "ForSaleList",
  "GraphSubscribe",
  "HalfImageHalfText",
  "HalfVideoHalfText",
  "HomepageHero",
  "HomepageHeroVideo",
  "HorizontalLine",
  "InThePress",
  "LargeImageSmallText",
  "MarketHealthIndex",
  "PortalViewsOverTimeGraph",
  "PropertyCarousel",
  "Quote",
  "ReferralLink",
  "RichText",
  "StaffProfile",
  "StampDutyCalculator",
  "ThreeColumnCta",
  "Timeline",
  "TrustpilotCarousel",
];

export const slices = sliceNames.reduce(
  (acc, name) => ({
    ...acc,
    // $FlowFixMe this works but flow hates it
    [name]: universal(import(`./src/slices/${name}/index`), {
      error: UniversalComponentError,
      ignoreBabelRename: true,
      key: "UniversalRender",
      loading: () => null,
    }),
  }),
  {},
);
